import styled from 'styled-components';

import {VisuallyHiddenLabel} from 'components/accessibility';
import {ButtonStyle} from 'components/design-guide';
import LoadingSpinner from 'shared/Icons/components/LoadingSpinner';
import {GLOBAL_TRANSLATIONS} from 'shared/IntlFormatMessage/translations/globalTranslations';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';
import {IconSize} from 'styles/Base';
import {Colors} from 'styles/Colors';
import {usePrevious} from 'utils/hooks';

const SPINNER_WIDTH_IN_PX = IconSize.PX_24;
const SPINNER_PADDING_IN_PX = 15;
const BUTTON_PADDING_IN_PX = parseInt(SPINNER_WIDTH_IN_PX, 10) + SPINNER_PADDING_IN_PX * 2;

const ButtonLoadingSpinnerWrapper = styled.div<{includeButtonPadding: boolean}>`
  padding-left: ${({includeButtonPadding}) => (includeButtonPadding ? `${SPINNER_PADDING_IN_PX}px` : '0px')};
  padding-right: ${({includeButtonPadding}) => (includeButtonPadding ? `${SPINNER_PADDING_IN_PX}px` : '0px')};
  display: flex;
`;

const LeftSidePadding = styled.div`
  padding-left: ${SPINNER_WIDTH_IN_PX}px;
`;
export const RightSidePadding = styled.div`
  padding-right: ${BUTTON_PADDING_IN_PX}px;
`;

interface Props {
  buttonStyle: ButtonStyle;
  active: boolean;
  includeButtonPadding: boolean;
  activeHiddenLabelCopy?: string;
}

const ActionLoadingSpinner = ({buttonStyle, active, activeHiddenLabelCopy, includeButtonPadding}: Props) => {
  const previouslyActive = usePrevious(active);
  const activeComplete = previouslyActive && !active;
  return (
    <ButtonLoadingSpinnerWrapper {...{includeButtonPadding}}>
      {active ? (
        <>
          <VisuallyHiddenLabel role="status">
            {activeHiddenLabelCopy || intlFormatSingleMessage(GLOBAL_TRANSLATIONS.SCREEN_READER_LOADING)}
          </VisuallyHiddenLabel>
          <LoadingSpinner props={{size: SPINNER_WIDTH_IN_PX, color: spinnerColor(buttonStyle)}} />
        </>
      ) : (
        <LeftSidePadding />
      )}
      {activeComplete && (
        <VisuallyHiddenLabel role="status">
          {intlFormatSingleMessage(GLOBAL_TRANSLATIONS.SCREEN_READER_LOADING_COMPLETE)}
        </VisuallyHiddenLabel>
      )}
    </ButtonLoadingSpinnerWrapper>
  );
};

const spinnerColor = (buttonStyle: ButtonStyle) => {
  switch (buttonStyle) {
    case ButtonStyle.PRIMARY:
      return Colors.WHITE;
    case ButtonStyle.SECONDARY:
      return Colors.CYAN;
    case ButtonStyle.TERTIARY:
      return Colors.NEAR_BLACK;
    case ButtonStyle.DESTRUCTIVE:
      return Colors.WARNING_RED;
    default:
      return Colors.WHITE;
  }
};

export default ActionLoadingSpinner;
